import { BadgeTemplate, PrinterModel, PrinterMedia } from "sharedTypes/badge"
import { calculatePrintInstructions } from "./badgeHelpers"

/**
 * Get initial template based on props
 */
const getInitialTemplate = (
  template?: BadgeTemplate,
  selectedPrinterModel?: PrinterModel,
  selectedPrinterMedia?: PrinterMedia,
): BadgeTemplate => {
  if (template) {
    return template
  }
  if (selectedPrinterModel && selectedPrinterMedia) {
    const widthMm = 100
    const heightMm = 62

    return {
      id: `new-${Date.now()}`,
      name: "New Badge Template",
      widthMm,
      heightMm,
      printerOrientation: calculatePrintInstructions({
        widthMm,
        heightMm,
        printerModel: selectedPrinterModel,
        printerMedia: selectedPrinterMedia,
      }),
      printerModel: selectedPrinterModel,
      printerMedia: selectedPrinterMedia,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      html: "<div></div>",
      manifest: { images: [], qrCodes: [] },
      badgeData: {
        elements: [],
      },
    }
  }

  // Fallback template
  const widthMm = 100
  const heightMm = 62

  return {
    id: `fallback-${Date.now()}`,
    name: "New Badge Template",
    widthMm,
    heightMm,
    printerOrientation: calculatePrintInstructions({
      widthMm,
      heightMm,
      printerModel: PrinterModel.QL_810_820_SERIES,
      printerMedia: PrinterMedia.DK_2205,
    }),
    printerModel: PrinterModel.QL_810_820_SERIES,
    printerMedia: PrinterMedia.DK_2205,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    html: "<div></div>",
    manifest: { images: [], qrCodes: [] },
    badgeData: {
      elements: [],
    },
  }
}

export default getInitialTemplate
